package team.platforma.auth_presentable.viewModel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import team.platforma.accountmanagerlib.getAccountManager
import team.platforma.auth_domain.UserUseCase

class AuthViewModel(private val userUseCase: UserUseCase) : ViewModel() {

    private val singletonScope = CoroutineScope(Dispatchers.Default + SupervisorJob())

    private val accountManager = getAccountManager()
    fun signIn(
        email: String,
        password: String,
        onSuccess: () -> Unit,
        onError: (errorMsg: String) -> Unit
    ) {
        singletonScope.launch {
            val complete = accountManager.createAccount(
                authToken = "it.v2871762h17yssga776qggq7ss7dgga7a76sdhggafFFYDHahbTTYGDYYSHyttay8837723",
                refreshToken = "it.v2871762h17yssga776qggq7ss7dgga7a76sdhggafFFYDHahbTTYGDYYSHyttay8837723",
                id = 111,
                email = email,
                password = password,
                isDebugAccount = true
            )
            delay(3000)

            if (complete) {
                withContext(Dispatchers.Main) {
                    onSuccess()
                }

            } else {
                withContext(Dispatchers.Main) {
                    onError("Ошибка авторизации")
                }

            }
        }

    }

    fun authUser(email: String, password: String, onSuccess: () -> Unit,) {
        viewModelScope.launch {
            userUseCase.network.auth(email, password)
                .onSuccess { data, code ->
                    val createAccount = accountManager.createAccount(
                        authToken = data.jwt.token,
                        refreshToken = data.jwt.refreshToken,
                        id = data.account.accountId,
                    )
                    if (createAccount) {
                        onSuccess()
                    }
                }
                .onFail { message, code ->  }
                .onException { message, code ->  }
        }
    }
}